import React,{useEffect,useState} from 'react'
import { useTranslation } from 'react-i18next';
import {
    Button,
    Col,
    Divider,
    Image,
    Row,
    Typography,
    notification,
    Space,
    Form,
    Input, Upload, Spin, Select, Skeleton, InputNumber, Switch, TreeSelect,
} from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import arrowLeft from '../../../src/img/arrow-left.png';
import addCat from '../../../src/img/add-category.png';
import stars from '../../../src/img/stars.png';
import openBook from '../../../src/img/open-book.png';
import imgIcon from '../../../src/img/image-icon.png';
import video from '../../../src/img/video.png';
import stepCircle from '../../../src/img/step-circle.png';
import API_SERVICE from 'shared/services/api-service';
import Parameters from 'shared/parameters';
import FrontendSidebar from 'views/FrontendSidebar/FrontendSidebar';
interface Props{
    nextStep:any,
    prevStep:any,
    values:any,
    handleCatData:any,
    handleFormData:any,
    catVal:any,
    draftCatVal:any,
    draftLevelVal:any,
    levelVal:any
}
interface hideHeader {
    hideHeader?: boolean;
  }
  const { Option } = Select;
function CourseLevel(props:Props,hideHeader:hideHeader) {
    const { nextStep, prevStep, handleCatData, handleFormData, values, catVal,draftCatVal,draftLevelVal, levelVal } = props
    const { t } = useTranslation();
    const history: any = useHistory();
    const RouteParams: any = useParams();
    const [categories, setCategories] = useState([] as any[]);
    const [levels, setLevels] = useState([] as any[]);
    const [instructors, setInstructors] = useState([] as any[]);
    const [saving, setSaving] = useState(false);
    const [lang, setLang] = useState('' as any);
    const refreshMetaData = async () => {
        try {
            if(Parameters.Mode !== 'CLIENT'){
            const {
                data: { data: { items: i } },
                } = await API_SERVICE.fetchUsers({ per_page: 1000 });
                setInstructors(i);
              const {
                data: { data: c },
              } = await API_SERVICE.fetchSubCategoryAdmin({ per_page: 1000 });
              setCategories(c);
              const {
                data: { data: { items: l } },
              } = await API_SERVICE.fetchLevelsAdmin({ per_page: 1000 });
              setLevels(l);
            }else{
              const {
                data: { data: c },
              } = await API_SERVICE.fetchSubCategories({ per_page: 1000 });
              setCategories(c);
              const {
                data: { data: { items: l } },
              } = await API_SERVICE.fetchLevels({ per_page: 1000 });
              setLevels(l);
            }

        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        }
    };
    // const [value, setValue] = useState<string>();

    // const onChange = (newValue: string) => {
    //     console.log(newValue);
    //     setValue(newValue);
    //     handleCatData(newValue)
    // };
    useEffect(() => {
        refreshMetaData();
        setLang(localStorage.getItem('language'));
    }, []);
    // useEffect(() => {
    //     handleCatData(draftCatVal && draftCatVal!= null || draftCatVal!= '' ? draftCatVal : catVal && catVal != null || catVal != "" ? catVal : '')
    //     form.setFieldsValue({
    //         'category_id': values.category_id !== '' ? values.category_id : draftCatVal && draftCatVal!= null || draftCatVal!= '' ? draftCatVal : catVal && catVal != null || catVal != "" ? catVal : '',
    //     });
    //     let formValCatId = values.category_id !== '' ? values.category_id : draftCatVal && draftCatVal!= null || draftCatVal!= '' ? draftCatVal : catVal && catVal != null || catVal != "" ? catVal : '';
    // }, [draftCatVal,catVal]);
    useEffect(() => {
        form.setFieldsValue({
            'level_id': draftLevelVal && draftLevelVal!= null || draftLevelVal!= '' ? draftLevelVal : levelVal && levelVal != null || levelVal != "" ? levelVal : '',
        });
    }, [draftLevelVal,levelVal]);

    const [form] = Form.useForm();
    const saveDraftData = () => {
        setSaving(true);
        let form_vals = form.getFieldsValue();
        // let localData = JSON.parse(localStorage.getItem("auth-token") || "")
        // console.log('localData',localData)
        // return
        form_vals['category_id'] = values.category_id !== '' ? values.category_id : draftCatVal && draftCatVal!= null || draftCatVal!= '' ? draftCatVal : catVal && catVal != null || catVal != "" ? catVal : '';
        console.log('draft saved value',form_vals)
        if(Parameters.Mode !== 'CLIENT'){
            API_SERVICE.createDraftCourseAdmin(form_vals).then((d) => {
                setSaving(false);
                history.goBack();
            }).catch((e) => {
                notification.error({ message: API_SERVICE.handleErrors(e) });
                setSaving(false);
            });
        }else {
            API_SERVICE.createDraftCourseInstructor(form_vals).then((d) => {
                setSaving(false);
                history.goBack();
            }).catch((e) => {
                notification.error({ message: API_SERVICE.handleErrors(e) });
                setSaving(false);
            });
        }
    }
  // after form submit validating the form data using validator
const submitFormData = () => {
    nextStep();
   // checking if value of first name and last name is empty show error else take to next step
  
};
const previousStep = () => {
    prevStep();
};
        return (
            <>
                <div className={hideHeader.hideHeader ? '' : ''}>
                    <div className='d-md-flex'>
                            <FrontendSidebar menuSelect={2} />
                            
                            <div className={Parameters.Mode === 'CLIENT' ? 'profile-tab-content-div mb-3': 'mb-3'} style={{width: '100%'}}>
                                {
                                !hideHeader.hideHeader && <>
                                    
                                    <div className="container-fluid">
                                        <div className='row'>
                                            {/* <div className='col-sm-12 mt-3'> */}
                                            <div className={lang == 'ar' ? 'row text-right' : 'col-sm-12 mt-3'}>
                                                <h3><span className='back-bg mr-4 cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span> {RouteParams['mode'] === 'create' ? t('course.create') : ''}</h3>    
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                            <div className="container-fluid">
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='bg-white p-3 br-5px'>
                                            <div className="row">
                                                <div className="col-md-12 pt-3 pb-3">
                                                    <div className="steps">
                                                        <ul id="progressbar" className="list-style-none w-100 d-flex">
                                                        <li className="w-100 steps-li">
                                                            <div className="progress">
                                                                <div className="progress-bar w-100"></div>
                                                            </div>
                                                            <div className="d-flex align-items-center mt-2">
                                                                <div className={lang == 'ar' ? 'text-right' : 'mr-3'}>
                                                                    <span className="icon-bg"><img src={addCat}/></span>
                                                                    <span className='step-circle'><img src={stepCircle} style={{width:'45px'}}/></span>
                                                                </div>
                                                                <div className={lang == 'ar' ? 'text-right mr-2' : 'mr-4'}>
                                                                    <p className="small mb-0 text-uppercase font-InterMedium text-4f46e5">{t('genDict.Step1')}</p>
                                                                    <p className="mb-0 text-uppercase small font-InterMedium">{t('genDict.SelectCreateACategory')}</p>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li className="w-100 steps-li">
                                                            <div className="progress">
                                                                <div className="progress-bar w-100"></div>
                                                            </div>
                                                            <div className="d-flex align-items-center mt-2">
                                                                <div className={lang == 'ar' ? 'text-right' : 'mr-3'}>
                                                                    <span className="icon-bg star"><img src={stars} style={{width:'29px'}}/></span>
                                                                    <span className='step-circle'><img src={stepCircle} style={{width:'45px'}}/></span>
                                                                </div>
                                                                <div className={lang == 'ar' ? 'text-right mr-2' : 'mr-4'}>
                                                                    <p className="small mb-0 text-uppercase font-InterMedium text-4f46e5">{t('genDict.Step2')}</p>
                                                                    <p className="mb-0 text-uppercase small font-InterMedium">{t('genDict.Select_SelectLevel')}</p>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li className="w-100 steps-li">
                                                            <div className="progress">
                                                                <div className="progress-bar"></div>
                                                            </div>
                                                            <div className="d-flex align-items-center mt-2">
                                                            {/* <div className={lang == 'ar' ? 'text-right' : 'd-flex align-items-center mt-2'}> */}
                                                                <div className={lang == 'ar' ? 'text-right' : 'mr-3'}>
                                                                    <span className="icon-bg video"><img src={video}/></span>
                                                                    <span className='step-circle'><img src={stepCircle} style={{width:'45px'}}/></span>
                                                                </div>
                                                                <div className={lang == 'ar' ? 'text-right mr-2' : 'mr-4'}>
                                                                    <p className="small mb-0 text-uppercase font-InterMedium text-4f46e5">{t('genDict.Step3')}</p>
                                                                    <p className="mb-0 text-uppercase small font-InterMedium">{t('genDict.CreateCourse')}</p>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li className="w-100 steps-li">
                                                            <div className="progress">
                                                                <div className="progress-bar"></div>
                                                            </div>
                                                            <div className="d-flex align-items-center mt-2">
                                                                <div className={lang == 'ar' ? 'text-right' : 'mr-3'}>
                                                                    <span className="icon-bg open-book"><img src={openBook}/></span>
                                                                    <span className='step-circle'><img src={stepCircle} style={{width:'45px'}}/></span>
                                                                </div>
                                                                <div className={lang == 'ar' ? 'text-right mr-2' : 'mr-4'}>
                                                                    <p className="small mb-0 text-uppercase font-InterMedium text-4f46e5">{t('genDict.Step4')}</p>
                                                                    <p className="mb-0 text-uppercase font-InterMedium small font-InterMedium">{t('genDict.Add_Content')}</p>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        </ul>
                                                    </div>
                                                    <div className="form-fields pl-4 pr-6rem">
                                                        <Form
                                                            form={form}
                                                            size='large' 
                                                            layout='vertical'
                                                            requiredMark={true}  
                                                            onFinish={submitFormData}
                                                        >
                                                            <fieldset>
                                                                <div className="row">
                                                                    {/* <div className="col-md-5 mt-5">
                                                                        <h5>Category</h5>
                                                                        <p className="text-secondary">This Information will be display the identify of the administrator</p>
                                                                    </div> */}
                                                                    {/* <div className="col-md-7 mt-5">
                                                                    <p className='mb-0'>Want to change? <a className='text-blue' id={'remove-cat-disable'} role={'button'}>Click here</a></p> */}
                                                                        {/* <Form.Item
                                                                            label={t('course.category.label')}
                                                                            // initialValue = { values.category_id !== '' ? values.category_id : catVal ? catVal : '' }
                                                                            name={'category_id'}
                                                                            rules={[
                                                                                { required: true, message: t('course.category.required') },
                                                                            ]}> */}
                                                                            {/* <select disabled className='select-cat-in-level form-control' onChange={handleFormData('category_id')}>
                                                                                <option value={''} selected>{t('category.choose')}</option>
                                                                                {
                                                                                    categories.map((level: any) => {
                                                                                        return <option value={level.id}>{level.name}</option>;
                                                                                    })
                                                                                }
                                                                            </select> */}
                                                                            {/* <TreeSelect
                                                                                showSearch
                                                                                treeNodeFilterProp='title'
                                                                                style={{ width: '100%' }}
                                                                                value={values.category_id !== '' ? values.category_id : draftCatVal && draftCatVal!= null || draftCatVal!= '' ? draftCatVal : catVal && catVal != null || catVal != "" ? catVal : ''}
                                                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                                                placeholder="Please select"
                                                                                disabled={true}
                                                                                allowClear
                                                                                treeDefaultExpandAll={false}
                                                                                className={'category_disabled'}
                                                                                onChange={onChange}
                                                                                treeData={categories}
                                                                            /> */}
                                                                            {/* <Select disabled>
                                                                                {
                                                                                    categories.map((level: any) => {
                                                                                        return <Option value={level.id}>{level.name}</Option>;
                                                                                    })
                                                                                }
                                                                            </Select> */}
                                                                        {/* </Form.Item> */}
                                                                    {/* </div> */}
                                                                </div>
                                                                {/* <hr>
                                                                </hr> */}
                                                                {/* <div className="row"> */}
                                                                <div className={lang == 'ar' ? 'row text-right' : 'row'}>
                                                                    <div className="col-md-5 mt-5">
                                                                        <h5>{t('genDict.SelectCourseLevel')}</h5>
                                                                        <p className="text-secondary">{t('genDict.SelectCourseLevelParagraph')}</p>
                                                                    </div>
                                                                    <div className="col-md-7 mt-5">
                                                                    <Form.Item
                                                                        label={t('course.level.label')}
                                                                        // initialValue = { levelVal ? levelVal : '' }
                                                                        name={'level_id'}
                                                                        rules={[
                                                                            { required: true, message: t('course.level.required') },
                                                                        ]}>
                                                                        <select className='form-control' onChange={handleFormData('level_id')}>
                                                                            <option value={''} selected>{t('level.choose')}</option>
                                                                            {
                                                                                levels.map((level: any) => {
                                                                                    return <option value={level.id}>{level.name}</option>;
                                                                                })
                                                                            }
                                                                        </select>
                                                                        {/* <Select>
                                                                            {
                                                                                levels.map((level: any) => {
                                                                                    return <Option value={level.id}>{level.name}</Option>;
                                                                                })
                                                                            }
                                                                        </Select> */}
                                                                    </Form.Item>
                                                                    </div>
                                                                </div>
                                                                <hr>
                                                                </hr>
                                                                {
                                                                    <Form.Item className='float-right' style={{width:'max-content'}}>
                                                                        <Button
                                                                            htmlType="submit"
                                                                            shape="round"
                                                                            size={'large'}
                                                                            className='btn btn-blue'
                                                                        >
                                                                           {t('genDict.saveAndContinue')}
                                                                        </Button>
                                                                    </Form.Item>
                                                                }
                                                                {
                                                                    <Form.Item className='float-right mr-3' style={{width:'max-content'}}>
                                                                        <Button
                                                                            // htmlType="submit"
                                                                            shape="round"
                                                                            size={'large'}
                                                                            className='btn btn-default'
                                                                            loading={saving}
                                                                            disabled={levelVal && levelVal != null && levelVal != '' ? true : false}
                                                                            onClick={saveDraftData}
                                                                        >
                                                                           {t('genDict.SaveAsDraft')}
                                                                        </Button>
                                                                    </Form.Item>
                                                                }
                                                            </fieldset>
                                                        </Form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                    </div>
                </div>
            
            </>
        )
}
export default CourseLevel